module.exports = __webpack_public_path__ + "img/3.b7d2ce40.svg";